import React from 'react';
import { theme } from '../../../config/theme';
import { RxHamburgerMenu } from 'react-icons/rx';

interface MenuIconProps {
    onOpen: () => void;
    size?: number;
}

const MenuIcon: React.FC<MenuIconProps> = ({ onOpen, size = 32, ...props }) => {
    return (
        <RxHamburgerMenu
            size={size}
            color={theme.colors.primary[1800]}
            onClick={onOpen}
            {...props}
        />
    );
};

export default MenuIcon;
